













import {defineComponent, reactive} from "@vue/composition-api"
import UserMenu from "@/components/layout/UserMenu.vue"
import {getUserSession} from "@/data/repos/authUserSession"

export default defineComponent({
  props: {},
  components: {UserMenu},
  setup() {
    const state = reactive({
      userName: "",
      loginName: "",
      displayUserMenu: false,
    })
    setTimeout(async() => {
      const sessionData = await getUserSession()
      state.userName = sessionData?.firstName + " " + sessionData?.lastName
      state.loginName = sessionData?.userName || ""
    }, 0)
    return {state}
  },
})
